import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { EnvconfigService } from './envconfig.service';

@Injectable({
    providedIn: 'root'
})
export class EncryptDecryptService {
    private key ;
    private iv:any;
    constructor(private environment: EnvconfigService) {
        this.key =  CryptoJS.enc.Utf8.parse(this.environment.get("EncryptKey"));
        this.iv = CryptoJS.enc.Utf8.parse(this.environment.get("EncryptIV"));
    }
    // Methods for the encrypt and decrypt Using AES
    encryptUsingAES256(text:any): any {
        let encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(text), this.key, {
            keySize: 128 / 8,
            iv: this.iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });
        // return encrypted.toString();
        return encrypted.ciphertext.toString(CryptoJS.enc.Hex);
    }

    encryptTokenUsingAES256(token:any): any {
        let encrypted = CryptoJS.AES.encrypt(token, this.key, {
            iv: this.iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });
        return encrypted.toString();
    }

    encrypt(token:string, key:string){
        return CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(token), key).toString();
    }

    decryptUsingAES256(decString:any) {
        let decrypted = CryptoJS.AES.decrypt(decString, this.key, {
            keySize: 128 / 8,
            iv: this.iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });
        return decrypted.toString(CryptoJS.enc.Utf8);
    }

    decrypt(s_token:string, s_key:string){
        let _toke_bytes = CryptoJS.AES.decrypt(s_token, s_key);
        let _token = _toke_bytes.toString(CryptoJS.enc.Utf8);
        return _token;
    }
}